import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home/home.service';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { Formatter } from '../common/services/formatter';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { PricingService } from './pricingConsent.service';
import { CommonUtility } from '../common/services/commonUtility';
@Component({
    selector: 'app-pricing-consent',
    templateUrl: './pricingConsent.template.html',
    styleUrls: ['./pricingConsent.style.css'],
    providers: [PricingService]
})
export class PricingConsentComponent implements OnInit {
    public consentAlreadyCaptured:boolean;
    public captureSuccess:boolean;
    public capturePricingData: boolean;
    public isError:boolean;
    private consentAuthToken: string;
    private consentref: string;
    private applicationId: string;
    private channel: string;
    public isBusinessError:boolean;
    public errorMessage = '';
    public consentType: string;
    public actionRequired: string;
    public successMessage: string = "";
    public authCode: string;
    public userRoleKey: string;
    public bundleSelection: boolean = false;
    public fppLite: boolean = false;
    public fppRequired: boolean = false;
    imgUrlDetails = [];
    public slideConfig = {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 5000
      };
    public pricingData;
    public stampfee = 0;
    public procfee = 0;
    public convfee = 0;
    public flexifee = 0;
    public amcfee = 0;
    public annualFeeVisible = false;
    public termLoan: boolean;
    public totalFeeAndCharges = 0;
    public approveSuccessMsg;
    public flexifeeflag = false;
    public amcFlag = false;

    constructor(
        private _homeService: HomeService,
        private _cookieHandler: CookieHandlerService,
        private _formatter: Formatter,
        private _routeContextProvider: RouteContextProvider,
        private _pricingService: PricingService
    ) { }
    public ngOnInit() {
        for (let i = 1; i <= 2; i++) {
            this.imgUrlDetails.push(
            { imageUrl: 'assets/img/FD-Short-Lead.png' }
           );
          }

        this.checkQueryParams();
       
    }

    private checkQueryParams(): void {
        this.consentAuthToken = encodeURIComponent(this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.consentToken));
        this.consentref = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.consentref);
        this.applicationId = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.applicationid);
        this.channel = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.consentChannel);
        this.consentType = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.consentType);
        this.actionRequired = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.actionRequired);
        this.authCode = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.authCode);
        this.userRoleKey = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.userRoleKey);
        if (this.consentType === 'APPROVAL_MAIL') {
            // EP Flow
            this.generateSytemToken();
        } else {
            // Journey Flow
            // this.authenticateSystem();
            this.getSystemToken();
        }
    }

    public getSystemToken() {
        this._pricingService.securedCookie().subscribe((response) => {
            if (CommonUtility.isValidResponse(response)) {
                if (response?.status === 'SUCCESS') {
                    this.validateConsentPricingData();
                }
            } else if (response.error && response.error.errorCode ) {
                this.isBusinessError = true;
                this.errorMessage = response.error.errorMessage;
            } else {
                this.isError = true;
            }
        });
    }
  
    private validateConsentPricingData() {
        const consentdata = {
            consentToken: this.consentAuthToken,
            employeeCaptured: false,
            employeeUserKey: '',
            channel: this.channel,
        };
        this._pricingService.validateConsentPricingData(this.consentAuthToken, this.applicationId)
            .subscribe((response: any) => {
                if (CommonUtility.isValidResponse(response)) {
                    this.pricingData = response.body;
                    this.bundleSelection = response.body.bundleSelectedFlag;
                    this.fppLite = response.body.fppLiteFlag;
                    this.fppRequired = response?.body?.fppRequired;
                    this.capturePricingData = true;
                    this.pricingData.tenureIs === 0 ? this.termLoan = true : this.termLoan = false;
                    this.pricingData.feesList.forEach((element) => {
                        if (element.feeCode === 'STAMPFEE') {
                            this.stampfee = element.feesInAmount;
                        } if (element.feeCode === 'PROCFEE') {
                            this.procfee = element.feesInAmount;
                        } if (element.feeCode === 'CONV') {
                            this.convfee = element.feesInAmount;
                        } if (element.feeCode === 'FLEXIFEE') {
                            this.flexifeeflag = true;
                            this.annualFeeVisible = true;
                            this.flexifee = element.feesInAmount;
                        } if (element.feeCode === 'AMCCHG') {
                            this.amcFlag = true;
                            this.amcfee = element.feesInAmount;
                        }
                    });
                    this.totalFeeAndCharges = this.pricingData.bundleamount +  this.stampfee + this.procfee + this.flexifee;
                } else if (response.error && response.error.errorCode ) {
                    this.isBusinessError = true;
                    this.errorMessage = response.error.errorMessage;
                } else {
                    this.isError = true;
                }
        },
        (error) => {
            console.log(error);
            this.isError = true;
        });
    }

    public approvePricing() {
        this.capturePricingData = false;
        this.validateConsentPricing();
    }

    private authenticateSystem(): void {
        const userClientId = this._homeService.GetClientIdForUser();
        this.setSecretKeyForClientId(userClientId);
    }
    private setSecretKeyForClientId(clientId: string): void {
        this._homeService.GetSecretKeyForBasedOnClientId(clientId).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                this._cookieHandler
                    .SetCookie(CommonConstants.CookieKeys.ClientId, clientId);
                this._cookieHandler
                    .SetCookie(CommonConstants.CookieKeys.SecretKey,
                        responseData.payload.secretKey);
                this.setSystemAuthToken(responseData.payload.secretKey, clientId);
            }
        });
    }
    private setSystemAuthToken(secretKey: string, clientId: string): void {
        this._homeService.GetSystemAuthToken({
            secretKey,
            clientId
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                const tokenObj = responseData.payload.tokens[0];
                console.log('tokens::', tokenObj);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.JWToken, tokenObj.token);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.JWTokenCO, tokenObj.token);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardKeyCO, tokenObj.guardKey);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardToken, this._formatter
                    .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardTokenCO, this._formatter
                    .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                this.validateConsentPricing();
            }
        });
    }


    // private authenticateForPricingApproval() {
    //     const reqdata = {
    //         userType: 2,
    //         authType: 'OFFICE_MAIL'
    //     }
    //     this._pricingService.getAuthCodeForPricingApproval(reqdata).subscribe((response: any)=>{
    //         if (CommonUtility.isValidResponse(response)) {
    //             console.log(response);
    //             let authcode = response.authcode;
    //             this.validateAuthCode(authcode);
    //         } else if (response.error && response.error.errorCode ) {
    //             this.isBusinessError = true;
    //             this.errorMessage = response.error.errorMessage;
    //         } else {
    //             this.isError = true;
    //         }
    // },
    // (error) => {
    //     console.log(error);
    //     this.isError = true;
    // });

    // }
    // private validateAuthCode(authCode) {
    //     const reqdata = {
    //         authcode: authCode
    //     }
    //     this._pricingService.validateAuthCode(reqdata).subscribe((response: any)=>{
    //         if (CommonUtility.isValidResponse(response)) {
    //             console.log(response);
    //             this.validatePricingApproval();
    //         } else if (response.error && response.error.errorCode ) {
    //             this.isBusinessError = true;
    //             this.errorMessage = response.error.errorMessage;
    //         } else {
    //             this.isError = true;
    //         }
    // },
    // (error) => {
    //     console.log(error);
    //     this.isError = true;
    // });

    // }
    public generateSytemToken(){
        const reqdata = {
            authCode: this.authCode,
            userRoleKey: this.userRoleKey
        }
        this._pricingService.generateServiceToken(reqdata).subscribe((response: any)=>{
            console.log(response);
            if (CommonUtility.isValidResponse(response)) {
                console.log(response);
                this.validatePricingApproval(response.payload.token);
            } else if (response.error.errorBean[0] && response.error.errorBean[0].errorCode ) {
                console.log("error with errorcode",response);
                this.isBusinessError = true;
                this.errorMessage = response.error.errorBean[0].errorMessage;
            } else {
                this.isError = true;
            }
    },
    (error) => {
        console.log("api errorrrrr",error);
        this.isError = true;
    });

    }
//    method for pricing approval
    private validatePricingApproval(data) {
        let reqBody =  {
            action: this.actionRequired,
            userRoleKey: this.userRoleKey
        }
      let authtoken = data;
        this._pricingService.validatePricingApproval(this.applicationId, authtoken, reqBody, this.actionRequired).subscribe((response: any)=>{
            console.log(response)
            if (CommonUtility.isValidResponse(response)) {
                if (response.status === "Success") {
                    this.captureSuccess = true;
                    this.successMessage = response.message;
                } else if (response.status === "Failure") {
                    this.isError = true;
                }
            } else if (response.errorCode != null) {
                console.log("response with errorCode")
                this.isBusinessError = true;
                this.errorMessage = response.errorMessage;
            } else {
                this.isError = true;
            }
    },
    (error) => {
        console.log("api error",error);
        if (error.error.errorCode != null) {
            console.log("response with errorCode")
            this.isBusinessError = true;
            this.errorMessage = error.error.errorMessage;
        } else {
            this.isError = true;
        }
    });
    }

    private validateConsentPricing() {
        const consentdata = {
            consentToken: this.consentAuthToken,
            employeeCaptured:false,
            employeeUserKey:'',
            channel:this.channel
        };
        this._pricingService.validateConsentPricing(consentdata, this.applicationId, this.consentref)
            .subscribe((response: any) => {
                if (CommonUtility.isValidResponse(response)) {
                    if (response?.body?.consentCaptured === 1) {
                        this.captureSuccess = true;
                        this.approveSuccessMsg = response?.body?.approvalMessage;
                    } else if (response?.body?.consentCaptured === 0) {
                        this.isError = true;
                    }
                } else if (response.error && response.error.errorCode ) {
                    this.isBusinessError = true;
                    this.errorMessage = response.error.errorMessage;
                } else {
                    this.isError = true;
                }
        },
        (error) => {
            console.log(error);
            this.isError = true;
        });
    }
}
